import { Dialog, DialogContent, DialogActions, Button, IconButton, makeStyles, CircularProgress, Box, Typography } from '@material-ui/core'
import { ArrowForwardIos, ArrowBackIos } from '@material-ui/icons'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
    overflowX: 'hidden',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: 'auto', 
    height: 'auto'
  },
  navigationButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  leftButton: {
    left: -16,
  },
  rightButton: {
    right: -20, 
  },
  image: {
    maxWidth: '90%',
    maxHeight: '100%',
    borderRadius: 8,
    objectFit: 'contain',
  },
  dialogContentText: {
    textAlign: 'center',
    // height: '70vh', 
    // minHeight: '56vh',
    margin: 0
  },
  imageCounter: {
    flexGrow: 1,
    textAlign: 'center',
    fontSize: '1.1rem',
    paddingLeft: '11%'
  },
  dialogPaper: {
    maxheight: '85vh',
    width: 'auto',
    height: 'auto',
  },
}))

const ImageContainer = ({ images, selectedImageIndex, handleClose, isLoading }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [currentIndex, setCurrentIndex] = useState(selectedImageIndex)
  const [imageError, setImageError] = useState(false)

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1))
    setImageError(false)
  }

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0))
    setImageError(false)
  }

  const handleImageError = () => {
    setImageError(true)
  }

  return (
    <Dialog open={selectedImageIndex !== null} onClose={handleClose} PaperProps={{ className: classes.dialogPaper }}>
      <DialogContent className={`${classes.dialogContent} ${classes.dialogContentText}`}>
        <div className={classes.imageContainer}>
            {isLoading
              ? <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                minWidth: '400px',
                gap: 2
              }}>
                <CircularProgress size={40} />
                <Typography variant="body2" color="textSecondary">
                  {t('Search.loading')}
                </Typography>
              </Box>
              : images && images.length > 0 && images[currentIndex]
                ? <>
                  {images.length > 1 && (
                    <IconButton className={`${classes.navigationButton} ${classes.leftButton}`} onClick={handlePrev}>
                      <ArrowBackIos />
                    </IconButton>
                  )}
                  {imageError
                    ? <Box sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      minHeight: '400px',
                      minWidth: '400px',
                      gap: 2
                    }}>
                      <Typography variant="body2" color="textSecondary">
                        {t('smartCatalog.imageNotAvailable')}
                      </Typography>
                    </Box>
                    : <img
                      src={images[currentIndex]}
                      alt="Box Image"
                      className={classes.image}
                      onError={handleImageError}
                    />
                  }
                  {images.length > 1 && (
                    <IconButton className={`${classes.navigationButton} ${classes.rightButton}`} onClick={handleNext}>
                      <ArrowForwardIos />
                    </IconButton>
                  )}
                </>
                : <Box sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '400px',
                  minWidth: '400px',
                  gap: 2
                }}>
                  <Typography variant="body2" color="textSecondary">
                    {t('smartCatalog.imageNotAvailable')}
                  </Typography>
                </Box>
            }
          </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.imageCounter}>
          {images && images.length > 0 ? `${currentIndex + 1} / ${images.length}` : '0 / 0'}
        </div>
        <Button onClick={handleClose} color="primary">
          {`${t('dataEntry.close')}`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ImageContainer.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedImageIndex: PropTypes.number,
  handleClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default ImageContainer
